import { arrayContainsAnotherArray } from "../lib/util";

const versionShowCombo = ["Up", "Down", "Up", "Down"];
const gridShowCombo = ["Down", "Down", "Down", "Up", "Up", "Up"];
const logsShowCombo = ["Left", "Left", "Down", "Down"];

class SecretComboService {
  _constructor() {
    this.keysPressArray = [];
  }

  addKeyAndCheckForCombo(keyCode) {
    this.startClearanceTimeout();

    return new Promise((resolve, reject) => {
      if (!this.keysPressArray) {
        this.keysPressArray = [keyCode];
      } else {
        this.keysPressArray.push(keyCode);
      }

      let versionCombo = arrayContainsAnotherArray(this.keysPressArray, versionShowCombo);

      if (versionCombo) {
        this.keysPressArray = [];
        resolve("version");
      }

      let gridCombo = arrayContainsAnotherArray(this.keysPressArray, gridShowCombo);

      if (gridCombo) {
        this.keysPressArray = [];
        resolve("grid");
      }

      let logsCombo = arrayContainsAnotherArray(this.keysPressArray, logsShowCombo);

      if (logsCombo) {
        this.keysPressArray = [];
        resolve("logs");
      }

      reject();
    });
  }

  checkIfKeyIsSupported(keyCode) {
    const supportedKeyCodes = [
      "Up",
      "Down",
      "Left",
      "Right",
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
    ];

    if (supportedKeyCodes.indexOf(keyCode)) {
      return true;
    }
  }

  startClearanceTimeout() {
    if (this.clearanceTimeout) {
      clearTimeout(this.clearanceTimeout);
    }

    this.clearanceTimeout = setTimeout(() => {
      this.keysPressArray = [];
    }, 2000);
  }
}

export default new SecretComboService();
